export default {"src":"/_next/static/media/mustard.2472c16a.svg","height":21,"width":19,"blurWidth":0,"blurHeight":0};